module.exports = __webpack_public_path__ + "img/headBeforIcon.36ebb959.png";